import moment from 'moment';

import { clearPackageOrderList } from './packageOrderList';
import { request } from '../axios/request';
import { getIsoDate } from 'theme/utils';

import {
  FETCH_PACKAGE_DELIVERY_RANGES_PENDING,
  FETCH_PACKAGE_DELIVERY_RANGES_REJECTED,
  FETCH_PACKAGE_DELIVERY_RANGES_FULFILLED,
  CLEAR_PACKAGE_DELIVERY_RANGES,
} from '../constants/packageDeliveryRanges';

const OMS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: FETCH_PACKAGE_DELIVERY_RANGES_PENDING,
});

const rejected = (error) => ({
  type: FETCH_PACKAGE_DELIVERY_RANGES_REJECTED,
  error,
});

const fulfilled = (data) => ({
  type: FETCH_PACKAGE_DELIVERY_RANGES_FULFILLED,
  data,
});

const clearDeliveryRanges = () => ({
  type: CLEAR_PACKAGE_DELIVERY_RANGES,
});

export const fetchPackageDeliveryRanges =
  (date = moment()) =>
  (dispatch) => {
    dispatch(clearDeliveryRanges());
    dispatch(clearPackageOrderList());
    dispatch(pending());

    request({
      method: 'get',
      url: OMS.OMS.PACKAGE_DELIVERY_RANGES,
      params: {
        date: getIsoDate(date),
      },
    })
      .then((response) => {
        dispatch(fulfilled(response.data));
      })
      .catch((error) => {
        dispatch(rejected({ apiError: error }));
      });
  };



// WEBPACK FOOTER //
// ./src/actions/packageDeliveryRanges.js